import React from "react";
import styles from "./FeaturedServices.module.css";
import CategoryCard from "../../../components/CategoryCard/CategoryCard";
import ServiceCard from "../../../components/ServiceCard/ServiceCard";

const categories = [
    {
        id: 1,
        icon: "/images/boy.svg",
        title: "Errand Running",
        serviceCount: 124,
    },
    {
        id: 2,
        icon: "/images/plane.svg",
        title: "Travel Assistance",
        serviceCount: 124,
    },
    {
        id: 3,
        icon: "/images/plate.svg",
        title: "Restaurant Reservation",
        serviceCount: 124,
    },
    {
        id: 4,
        icon: "/images/cart.svg",
        title: "Personal Shopping",
        serviceCount: 124,
    },
];

const services = [
    {
        id: 1,
        image: "/images/service1.png",
        agentAvatar: "/images/1.svg",
        agentName: "Grace Helen",
        title: "Book Restaurant Reservations in Lagos",
        rating: 4.9,
        reviewCount: 234,
        location: "Lagos, Nigeria",
        price: 15000,
    },
    {
        id: 2,
        image: "/images/service2.png",
        agentAvatar: "/images/2.svg",
        agentName: "Temitope Monday",
        title: "Airport Pickup & Drop-off Arrangement",
        rating: 4.7,
        reviewCount: 134,
        location: "Lagos, Nigeria",
        price: 15000,
    },
    {
        id: 3,
        image: "/images/service3.png",
        agentAvatar: "/images/3.svg",
        agentName: "George Federick",
        title: "Personal Shopping Assistant",
        rating: 4.7,
        reviewCount: 24,
        location: "Lagos, Nigeria",
        price: 15000,
    },
    {
        id: 4,
        image: "/images/service4.png",
        agentAvatar: "/images/1.svg",
        agentName: "Bola Ahmed",
        title: "Travel Itinerary Planning",
        rating: 5.0,
        reviewCount: 414,
        location: "Lagos, Nigeria",
        price: 15000,
    },
];

const trustLogos = [
    { src: "./images/google.svg", alt: "Google" },
    { src: "./images/ms.svg", alt: "Microsoft" },
    { src: "./images/deloti.svg", alt: "Deloitte" },
    { src: "./images/pwc.svg", alt: "PWC" },
    { src: "./images/kpmg.svg", alt: "KPMG" },
];

function FeaturedServices() {
    return (
        <>
            <section className={styles.section}>

                <div className={styles.trustContainer}>
                    <h3>Trusted by:</h3>
                    <div className={styles.trustWrapper}>
                        <div className={styles.trustImg}>
                            {trustLogos.map((logo, index) => (
                                <img key={index} src={logo.src} alt={logo.alt} />
                            ))}
                            {/* Duplicate only for mobile scroll */}
                            <span className={styles.mobileOnly}>
                                {trustLogos.map((logo, index) => (
                                    <img key={`dup-${index}`} src={logo.src} alt={logo.alt} />
                                ))}
                            </span>
                        </div>
                    </div>
                </div>

                <div className={styles.categoryWrapper}>
                    <div className={styles.categoryRow}>
                        {[...categories, ...categories].map((category, index) => (
                            <CategoryCard
                                key={index}
                                icon={category.icon}
                                title={category.title}
                                serviceCount={category.serviceCount}
                            />
                        ))}
                    </div>
                </div>

                <div className={styles.serviceContainer}>
                    <div className={styles.serviceHeading}>
                        <h3>Featured Services</h3>
                        <p>Handpicked concierge services our clients love.</p>
                    </div>

                    <div className={styles.serviceWrapper}>

                        <div className={styles.serviceRow}>
                            {services.map((service, index) => (
                                <ServiceCard
                                    key={index}
                                    image={service.image}
                                    agentAvatar={service.agentAvatar}
                                    agentName={service.agentName}
                                    title={service.title}
                                    rating={service.rating}
                                    reviewCount={service.reviewCount}
                                    location={service.location}
                                    price={service.price}
                                />
                            ))}
                        </div>


                    </div>
                </div>

            </section>
        </>
    );
}

export default FeaturedServices